// extracted by mini-css-extract-plugin
export default {"normalXl2":"styles_normalXl2__SwNcp","normalXl":"styles_normalXl__PHKNu","normalLg":"styles_normalLg__H+0ym","normalMd":"styles_normalMd__WIhBq","normalSm":"styles_normalSm__wdly9"};